export default "__VITE_ASSET__DamtEXi3__"